import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { environment } from '../../environments/environment.development';
import { authReducer, AuthState } from './auth/auth.reducer';
import { userAuthReducer, UserAuthState } from './user/auth/user-auth.reducer';
import { toastReducer, ToastState } from './toast/toast.reducer';
import { warehouseReducer, WarehouseState } from './gse/inventory/warehouse/warehouse.reducer';
import { equipmentReducer, EquipmentState } from './gse/inventory/equipment/equipment.reducer';
import { sparePartReducer, sparePartState } from './gse/inventory/spare-part/spare-part.reducer';
import {
  manufacturerReducer,
  ManufacturerState,
} from './gse/inventory/lookups/manufacturer/manufacturer.reducer';
import { countryReducer, CountryState } from './gse/inventory/lookups/country/country.reducer';
import {
  procurementReducer,
  ProcurementState,
} from './gse/maintenance/procurement/procurement.reducer';
import {
  serviceRequestReducer,
  ServiceRequestState,
} from './gse/maintenance/service-request/service-request.reducer';
import { jobCardReducer, JobCardState } from './gse/maintenance/job-card/job-card.reducer';
import {
  pmNotificationReducer,
  PmNotificationState,
} from './gse/maintenance/pm-notification/pm-notification.reducer';

import {
  dailyCheckinReducer,
  DailyCheckinState,
} from './gse/maintenance/daily-checkin/daily-checkin.reducer';
import { hodReducer, HodState } from './gse/inventory/lookups/hod/hod.reducer';
import {
  supervisorReducer,
  SupervisorState,
} from './gse/inventory/lookups/supervisor/supervisor.reducer';
import {
  technicianReducer,
  TechnicianState,
} from './gse/inventory/lookups/technician/technician.reducer';
import { plannerReducer, PlannerState } from './gse/inventory/lookups/planner/planner.reducer';
import { delegationReducer, DelegationState } from './gse/delegation/delegation.reducer';
import {
  inventoryCorrectionReducer,
  InventoryCorrectionState,
} from './gse/maintenance/inventory-correction/inventory-correction.reducer';
import {
  maintenanceDashboardReducer,
  MaintenanceDashboardState,
} from './gse/maintenance/maintenance-dashboard/maintenance-dashboard.reducer';
import { reportReducer, ReportState } from './gse/reports/report.reducer';
import {
  hodDashboardReducer,
  HodDashboardState,
} from './gse/inventory/hod-dashboard/hod-dashboard.reducer';
import {
  adminUserDashboardReducer,
  AdminUserDashboardState,
} from './administration/user-dashboard/user-dashboard.reducer';
import {
  administrationUsersReducer,
  AdministrationUsersState,
} from './administration/users/users.reducer';
import { pettyCashReducer, PettyCashState } from './gse/maintenance/petty-cash/petty-cash.reducer';
import {
  fboLocationsReducer,
  FboLocationsState,
} from './administration/fbo-locations/fbo-locations.reducer';
import {
  spareAllocationReducer,
  SpareAllocationState,
} from './gse/maintenance/spare-allocation/spare-allocation.reducer';
import {
  equipmentRentalReducer,
  EquipmentRentalState,
} from './gse/inventory/equipment-rental/equipment-rental.reducer';

export interface AppState {
  router: RouterReducerState;
  auth: AuthState;
  userAuth: UserAuthState;
  toast: ToastState;
  warehouse: WarehouseState;
  equipment: EquipmentState;
  sparePart: sparePartState;
  manufacturer: ManufacturerState;
  country: CountryState;
  procurement: ProcurementState;
  serviceRequest: ServiceRequestState;
  jobCard: JobCardState;
  pmNotification: PmNotificationState;
  dailyCheckin: DailyCheckinState;
  hod: HodState;
  supervisor: SupervisorState;
  technician: TechnicianState;
  planner: PlannerState;
  delegation: DelegationState;
  inventoryCorrection: InventoryCorrectionState;
  maintenanceDashboard: MaintenanceDashboardState;
  report: ReportState;
  hodDashboard: HodDashboardState;
  adminUserDashboard: AdminUserDashboardState;
  administrationUsers: AdministrationUsersState;
  pettyCash: PettyCashState;
  fboLocations: FboLocationsState;
  spareAllocation: SpareAllocationState;
  equipmentRental: EquipmentRentalState;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  auth: authReducer,
  userAuth: userAuthReducer,
  toast: toastReducer,
  warehouse: warehouseReducer,
  equipment: equipmentReducer,
  sparePart: sparePartReducer,
  manufacturer: manufacturerReducer,
  country: countryReducer,
  procurement: procurementReducer,
  serviceRequest: serviceRequestReducer,
  jobCard: jobCardReducer,
  pmNotification: pmNotificationReducer,
  dailyCheckin: dailyCheckinReducer,
  hod: hodReducer,
  supervisor: supervisorReducer,
  technician: technicianReducer,
  planner: plannerReducer,
  delegation: delegationReducer,
  inventoryCorrection: inventoryCorrectionReducer,
  maintenanceDashboard: maintenanceDashboardReducer,
  report: reportReducer,
  hodDashboard: hodDashboardReducer,
  adminUserDashboard: adminUserDashboardReducer,
  administrationUsers: administrationUsersReducer,
  pettyCash: pettyCashReducer,
  fboLocations: fboLocationsReducer,
  spareAllocation: spareAllocationReducer,
  equipmentRental: equipmentRentalReducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
